module.exports = __webpack_public_path__ + "static/media/bnr3.8526fb65.jpg";